import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Cyber Bullying",
  "description": "",
  "published": "2007-07-04T00:00:00.000Z",
  "redirect_from": ["/blog/cyber-bullying/swizec/178"],
  "categories": "food for thought",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Apparently cyber bullying is enough of an issue for some that they decided to `}<a parentName="p" {...{
        "href": "http://www.youtube.com/watch?v=csS_RnOhd-Q"
      }}>{`make`}</a>{` some `}<a parentName="p" {...{
        "href": "http://www.youtube.com/watch?v=QYaWNYXpBis"
      }}>{`advertisments`}</a>{` touting against it. I'm wondering why this is such an issue to people and most of all why they chose such a slogan that exempts so many people from obeying it.`}</p>
    <p>{`Let's be more specific, the slogan goes like so: "If you woudln't say it in person, why say it online?" now I'm certain many of you can see where this is a problem. Firstly it expects everyone seeing the advertisment to be an annoying hypocrite who doesn't say what they think, but rather smiles at your face then stabs you in the back. This is wrong. It is in fact so very wrong that it should be made an issue and touted against. It would, for example, save many people from being friends with those who don't even like them.`}</p>
    <p>{`There's a bunch more stuff that could be said about why hypocrisy is bad, but let's not. Let's see why cyber bullying is an issue at all, because I for one fail to understand. When somebody says things you don't like to you online you can close the chat window, go to another forum or thread, simply skip their comments or even block the person from ever talking to you again. Why is there an issue then, when you have so many options? Not to mention nobody should really care about what somebody half the world away thinks about them because it just simply is not important at all.`}</p>
    <p>{`I close on something a wise maths teacher once said to me "If it's true then it isn't an insult and shoudln't be insulting or hurtful"`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      